import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { Building2, ArrowLeft } from "lucide-react";

export const ActiveStudioBanner = () => {
  const { 
    isSuperAdmin, 
    activeStudio, 
    isViewingOtherStudio, 
    resetToOwnStudio 
  } = useAuth();

  const isVisible = isSuperAdmin && isViewingOtherStudio && activeStudio;

  // Add padding to body when banner is visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.paddingTop = "40px";
    } else {
      document.body.style.paddingTop = "0";
    }
    return () => {
      document.body.style.paddingTop = "0";
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        left: 250,
        right: 0,
        zIndex: 1001,
        background: "linear-gradient(135deg, #1a1a2e 0%, #2d2d44 100%)",
        color: "white",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        fontSize: 13,
        fontWeight: 500,
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        height: 40
      }}
      data-testid="active-studio-banner"
    >
      <Building2 size={16} style={{ color: "var(--sun-gold)" }} />
      <span>
        Du betrachtest: <strong style={{ color: "var(--sun-gold)" }}>{activeStudio.name}</strong>
      </span>
      <button
        onClick={resetToOwnStudio}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          padding: "4px 10px",
          borderRadius: 16,
          border: "1px solid var(--sun-gold)",
          background: "transparent",
          color: "var(--sun-gold)",
          fontSize: 11,
          fontWeight: 600,
          cursor: "pointer",
          transition: "all 0.2s"
        }}
        onMouseEnter={(e) => {
          e.target.style.background = "var(--sun-gold)";
          e.target.style.color = "#1a1a2e";
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "transparent";
          e.target.style.color = "var(--sun-gold)";
        }}
        data-testid="reset-studio-btn"
      >
        <ArrowLeft size={12} />
        Zurück zu meinem Studio
      </button>
    </div>
  );
};

export default ActiveStudioBanner;
